import { c as _c } from "react/compiler-runtime";
import { StoryCover } from "./story-cover";
import { cn } from "@/lib/utils";
interface StoryCoverTileProps {
  coverUrl: string | null;
  title: string;
  sizes?: string;
  priority?: boolean;
  /** Optional corner badge, e.g. "New" (accent) or "Full" (dark). */
  badge?: {
    label: string;
    position?: "left" | "right";
    tone?: "accent" | "dark";
  };
  /** Hover zoom intensity. "sm" = 1.05/500ms (default), "lg" = 1.10/700ms. */
  hoverZoom?: "sm" | "lg";
  /** Drop shadow on the box. Default true. */
  shadow?: boolean;
  /** Extra classes for the outer 3:4 box (e.g. spacing). */
  className?: string;
  /** Overlays rendered inside the box (hover CTA, gradient captions, …). */
  children?: React.ReactNode;
}

/**
 * Reusable 3:4 story-cover thumbnail with hover-zoom and an optional corner
 * badge. Shared by the discovery rows and browse cards so the card visuals
 * stay in one place. Render inside a `group` element to enable the hover zoom;
 * pass overlays as `children`.
 */
export function StoryCoverTile(t0) {
  const $ = _c(18);
  const {
    coverUrl,
    title,
    sizes,
    priority,
    badge,
    hoverZoom: t1,
    shadow: t2,
    className,
    children
  } = t0;
  const hoverZoom = t1 === undefined ? "sm" : t1;
  const shadow = t2 === undefined ? true : t2;
  const t3 = shadow && "shadow-lg";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = cn("relative aspect-[3/4] overflow-hidden rounded-xl", t3, className);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = hoverZoom === "lg" ? "duration-700 group-hover:scale-110" : "duration-500 group-hover:scale-105";
  let t6;
  if ($[3] !== t5) {
    t6 = cn("object-cover transition-transform", t5);
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== coverUrl || $[6] !== priority || $[7] !== sizes || $[8] !== t6 || $[9] !== title) {
    t7 = <StoryCover coverUrl={coverUrl} title={title} fill={true} sizes={sizes} priority={priority} className={t6} />;
    $[5] = coverUrl;
    $[6] = priority;
    $[7] = sizes;
    $[8] = t6;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== badge) {
    t8 = badge && <span className={cn("absolute top-2 rounded px-2 py-0.5 text-[10px] font-bold uppercase text-white shadow-sm", badge.position === "right" ? "right-2" : "left-2", badge.tone === "dark" ? "bg-slate-900/80 backdrop-blur-sm" : "bg-accent")}>{badge.label}</span>;
    $[11] = badge;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== children || $[14] !== t4 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className={t4}>{t7}{t8}{children}</div>;
    $[13] = children;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}